import * as API from "../../../Utils/Services/api";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { formatEther, formatUnits, parseUnits } from "ethers";
import { toast } from "react-toastify";
import Loading from "../../Loading/Loading";
import { useLanguage } from "../../LanguageContext";
import translation from "../../Translations/translation.json";
import "./CreatePositions.css";
import {
  createAndInitPool,
  getPoolAddress,
  mintLiquidity,
  quoteMintAmountsGivenOneSide,
  sortLex,
  ticksFromMinMaxPrice,
} from "../../../helpers/v3/v3";
import { ADDRS } from "../../../Contracts/V3/addresses";
import { publicClient } from "../../../Contracts/V3/client";
import { ABIS, ERC20 } from "../../../Contracts/V3/abis";
import { nearestUsableTick, spacingForFee } from "../../../Utils/tickMath";
import { useDebouncedMintQuote } from "../../../hook/useDebouncedMintQuote";

const CreatePositionsV3 = () => {
  const { toggleLanguage, language } = useLanguage();
  const containerRef = useRef(null);
  const translate = (key) => {
    const keys = key.split(".");
    return (
      keys.reduce((obj, keyPart) => obj?.[keyPart], translation[language]) ||
      key
    );
  };
  const navigate = useNavigate();

  const [toggle, setToggle] = useState(true);
  const [tokenData, setTokenData] = useState([]);
  const [selectedRadio, setSelectedRadio] = useState(3000);
  const [selectedRadioP, setSelectedRadioP] = useState("93%");
  const [value, setValue] = useState();
  const [value2, setValue2] = useState();
  const [depositVal, setDepositVal] = useState();
  const [estimateValue1, setEstimateValue1] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [estimateValue2, setEstimateValue2] = useState("");
  const [selectToken, setSelectToken] = useState(null);
  const [selectedToken, setSelectedToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [allTokensLoading, setAllTokensLoading] = useState(false);
  const [depositloader, setDepositloader] = useState(false);
  const [checkPoolExist, setCheckPoolExist] = useState(false);
  const [poolAddress, setPoolAddress] = useState(null);
  const debounceTimeout = useRef(null);
  const [totalAllTokens, setTotalAllTokens] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [fullRange, setFullRange] = useState(false);
  const [debouncedMinPrice, setDebouncedMinPrice] = useState("");
  const [debouncedMaxPrice, setDebouncedMaxPrice] = useState("");

  const address = sessionStorage.getItem("account");
  const ZERO = "0x0000000000000000000000000000000000000000";
  const [t0, setT0] = useState(ADDRS?.TOKEN0 || "");
  const [initialPriceInput, setInitialPriceInput] = useState("");
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(0);
  const [rangeMode, setRangeMode] = useState("full");
  const [side, setSide] = useState("");

  const [currentPrice, setCurrentPrice] = useState("");

  const [slot0, setSlot0] = useState(null);
  const [tickLower, setTickLower] = useState(null);
  const [tickUpper, setTickUpper] = useState(null);

  const [dec0, setDec0] = useState(18);
  const [dec1, setDec1] = useState(18);

  const lower = (v) => (typeof v === "string" ? v?.toLowerCase() : "");

  const [step, setStep] = useState("PAIR");

  const [isSwap, setIsSwap] = useState(false);

  useEffect(() => {
    if (!currentPrice) return;
    if (rangeMode !== "custom") return;

    const price = Number(currentPrice);
    if (!price || isNaN(price)) return;

    const min = price * 0.5; // -50%
    const max = price * 2.0; // +100%

    setMinPrice(min);
    setMaxPrice(max);
  }, [currentPrice, rangeMode]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedMinPrice(minPrice);
      setDebouncedMaxPrice(maxPrice);
    }, 500);

    return () => clearTimeout(handler);
  }, [minPrice, maxPrice]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getAllTokenDetail = async (
    page = 1,
    size = rowsPerPage,
    filter = ""
  ) => {
    try {
      setAllTokensLoading(true);
      const data = {
        page,
        size,
        filter,
      };
      const resp = await API.getLiquidityTokenV3(data);
      const tokens = resp.data.tokens || [];
      setTokenData((prev) => (page === 1 ? tokens : [...prev, ...tokens]));
      setTotalAllTokens(resp.data.total);
      setTotalPages(Math.ceil(resp.data.total / size));
      setAllTokensLoading(false);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Error");
      setAllTokensLoading(false);
      if (page === 1) setTokenData([]);
      setTotalAllTokens(0);
      setTotalPages(1);
    }
  };

  useEffect(() => {
    getAllTokenDetail();
  }, []);

  const selectHandler = (e) => {
    const filter = e.target.value;
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      setCurrentPage(1);
      setTokenData([]);
      getAllTokenDetail(1, rowsPerPage, filter);
    }, 500);
  };

  const handleToggle = () => {
    setToggle(!toggle);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  // const percentageMapping = {
  //   // 0.01: translate("addLiquidity.bestForVeryStable"),
  //   0.05: translate("addLiquidity.bestForStable"),
  //   0.3: translate("addLiquidity.bestForMost"),
  //   "1.00": translate("addLiquidity.bestForExotic"),
  // };
  const percentageMapping = {
    500: { display: "0.05%", label: translate("addLiquidity.bestForStable") },
    3000: { display: "0.30%", label: translate("addLiquidity.bestForMost") },
    10000: { display: "1.00%", label: translate("addLiquidity.bestForExotic") },
  };

  function pow1_0001(n) {
    return Math.pow(1.0001, n);
  }
  function tickToPrice(tick, dec0, dec1) {
    const scale = Math.pow(10, Number(dec1) - Number(dec0));
    return pow1_0001(tick) * scale;
  }

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setPoolAddress("");
      setInitialPriceInput("");
      try {
        const token0 = t0;
        const token1 = selectedToken?.address;
        if (!token1) return;
        const p = await getPoolAddress(token0, token1, Number(selectedRadio));
        if (cancelled) return;
        if (!p || lower(p) === lower(ZERO)) {
          setPoolAddress("");
          return;
        }
        setPoolAddress(p);
        setCheckPoolExist(true);

        const s0 = await publicClient.readContract({
          address: p,
          abi: ABIS.pool,
          functionName: "slot0",
        });

        if (cancelled) return;
        const sqrtPriceX96 = s0?.[0];
        const currentTick = Number(s0?.[1]);
        if (
          !sqrtPriceX96 ||
          sqrtPriceX96 === 0n ||
          !Number.isFinite(currentTick)
        ) {
          setSlot0(null);
          return;
        }
        setSlot0({ sqrtPriceX96, currentTick });
      } catch (e) {
        console.log("Error", e);
        if (cancelled) return;
      }
    }

    load();
  }, [
    t0,
    selectedRadio,
    estimateValue1,
    estimateValue2,
    address,
    selectedToken?.address,
  ]);

  useEffect(() => {
    if (!slot0) {
      setCurrentPrice(null);
      return;
    }

    try {
      const price = tickToPrice(slot0.currentTick, dec0, dec1);
      setCurrentPrice(price);
    } catch (err) {
      console.error("Price calculation error:", err);
      setCurrentPrice(null);
    }
  }, [slot0, dec0, dec1]);

  const handleSelection = (event) => {
    const value = event.target.value;
    setSelectedRadio(Number(value));
    setSelectedRadioP(percentageMapping[value].label);
    checkPool(selectedToken?.address, value);
  };

  const checkPool = async (data, value) => {
    try {
      if (!data) return;
      const poolAddress = await getPoolAddress(data, t0, Number(value));
      poolAddress !== ZERO ? setCheckPoolExist(true) : setCheckPoolExist(false);
    } catch (e) {
      console.log("checkpool error", e);
    }
  };

  const saveHandler = async (data) => {
    setSelectedToken(data.token);
    checkPool(data?.token.address, selectedRadio);
  };

  // const createPairHandler = async () => {
  //   try {
  //     setLoading(true);

  //     const { pool: p } = await createAndInitPool({
  //       token0: t0,
  //       token1: selectedToken.address,
  //       fee: Number(selectedRadio),
  //       initPrice: initialPriceInput,
  //     });

  //     setPoolAddress(p);
  //     if (p) setCheckPoolExist(true);

  //     setShowModal(true);
  //     setLoading(false);
  //   } catch (e) {
  //     console.error("CreatePool", e);
  //     setLoading(false);

  //   }
  // };
  const createPairHandler = async () => {
    try {
      if (!address) {
        toast.warn(translate("banner.connectmetamask"));
        return;
      }
      setLoading(true);
      if (!selectedToken || !selectedToken?.address) {
        toast.warn(translate("createLiq.validTokenpair"));
        setLoading(false);
        return;
      }
      if (
        !initialPriceInput ||
        isNaN(initialPriceInput) ||
        Number(initialPriceInput) <= 0
      ) {
        toast.warn(translate("createLiq.validInitalPrice"));
        setLoading(false);
        return;
      }

      const { pool: p } = await createAndInitPool({
        token0: t0,
        token1: selectedToken?.address,
        fee: Number(selectedRadio),
        initPrice: initialPriceInput,
      });

      if (p) {
        setPoolAddress(p);
        setCheckPoolExist(true);
        toast.success(translate("createLiq.poolCreated"));
        setShowModal(true);
        setInitialPriceInput("");
      } else {
        toast.error(translate("createLiq.failedCreatePool"));
      }
    } catch (e) {
      console.error("CreatePool Error:", e);
      toast.error(translate("createLiq.somethingWrong"));
    } finally {
      setLoading(false);
    }
  };

  const depositHandler = async () => {
    try {
      if (!address) {
        toast.warn(translate("banner.connectmetamask"));
        return;
      }

      setDepositloader(true);
      const amount0Desired = parseUnits(
        String(estimateValue1 || "0"),
        Number(dec0)
      );
      const amount1Desired = parseUnits(
        String(estimateValue2 || "0"),
        Number(dec1)
      );

      const rc = await mintLiquidity({
        token0: t0,
        token1: selectedToken?.address,
        fee: Number(selectedRadio),
        amount0Desired,
        amount1Desired,
        debugLabel: "AddLiquidity.mint",
        rangeMode: rangeMode,
        minPrice: parseFloat(minPrice),
        maxPrice: parseFloat(maxPrice),
      });

      const resp = await API.addLiquidityV3({
        tokenAddress: selectedToken?.address,
        poolAddress: rc.pool,
        wallet: address,
        tokenAmount: parseFloat(estimateValue2),
        ethwAmount: parseFloat(estimateValue1),
        ethwReserve: parseFloat(formatEther(rc.ethwReserve)),
        tokenReserve: parseFloat(formatEther(rc.tokenReserve)),
        sqrtPriceX96: Number(rc.sqrtPriceX96),
        feeTier: Number(rc.position.fee),
        tick: Number(rc.currentTick),
        tickSpacing: Number(rc.spacing),
        createdBlock: Number(rc.receipt.blockNumber),
        createdTx: rc.txHash,
        circularSupply: Number(formatEther(rc.totalSupply)),
        createdVia: null,
        tokenBalance: parseFloat(formatEther(rc.tokenBalance)),
        lpTokenId: Number(rc.tokenId),
        minPrice:
          rangeMode === "full"
            ? parseFloat(rc.fullMinTickPrice)
            : parseFloat(minPrice),
        maxPrice:
          rangeMode === "full"
            ? parseFloat(rc.fullMaxTickPrice)
            : parseFloat(maxPrice),
      });

      toast.success(translate("createLiq.liquidityAdded"));
      setDepositloader(false);
    } catch (e) {
      console.error("error:", e);
      setDepositloader(false);
      toast.error(translate("createLiq.somethingWrong"));
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleTokenInput = (e) => {
    setSide("1");
    const value = e.target.value !== "" ? e.target.value : "";
    setEstimateValue2(value);
  };
  const handleETHWInput = (e) => {
    setSide("0");
    const value = e.target.value !== "" ? e.target.value : "";
    setEstimateValue1(value);
  };

  // useEffect(() => {
  //   try {
  //     const { tickLower, tickUpper } = ticksFromMinMaxPrice({
  //       minPrice,
  //       maxPrice,
  //       fee: Number(selectedRadio),
  //       dec0,
  //       dec1,
  //     });

  //     setTickLower(tickLower);
  //     setTickUpper(tickUpper);
  //   } catch (err) {
  //     console.error("ticksFromMinMaxPrice failed:", err);
  //   }
  // }, [minPrice, maxPrice, selectedRadio, dec0, dec1]);
  useEffect(() => {
    if (!debouncedMinPrice || !debouncedMaxPrice) return;

    try {
      const { tickLower, tickUpper } = ticksFromMinMaxPrice({
        minPrice: debouncedMinPrice,
        maxPrice: debouncedMaxPrice,
        fee: Number(selectedRadio),
        dec0,
        dec1,
      });

      setTickLower(tickLower);
      setTickUpper(tickUpper);
    } catch (err) {
      console.error("ticksFromMinMaxPrice failed:", err);
    }
  }, [debouncedMinPrice, debouncedMaxPrice, selectedRadio, dec0, dec1]);

  // useEffect(() => {
  //   // Skip if required values are missing
  //   if (!minPrice || !maxPrice) return;

  //   const handler = setTimeout(() => {
  //     try {
  //       const { tickLower, tickUpper } = ticksFromMinMaxPrice({
  //         minPrice,
  //         maxPrice,
  //         fee: Number(selectedRadio),
  //         dec0,
  //         dec1,
  //       });

  //       setTickLower(tickLower);
  //       setTickUpper(tickUpper);
  //     } catch (err) {
  //       console.error("ticksFromMinMaxPrice failed:", err);
  //     }
  //   }, 500);

  //   return () => clearTimeout(handler);
  // }, [minPrice, maxPrice, selectedRadio, dec0, dec1]);

  const { quote, _, error } = useDebouncedMintQuote({
    token0: t0,
    token1: selectedToken?.address,
    fee: Number(selectedRadio),
    tickLower: rangeMode === "full" ? -887272 : tickLower,
    tickUpper: rangeMode === "full" ? 887272 : tickUpper,
    side,
    amountInput: side === "0" ? estimateValue1 : estimateValue2,
    dec0: 18,
    dec1: 18,
    delay: 500,
    quoter: quoteMintAmountsGivenOneSide,
  });

  useEffect(() => {
    const [token0, token1] = sortLex(t0, selectedToken?.address);

    const orderChanged = t0?.toLowerCase() !== token0?.toLowerCase();
    setIsSwap(orderChanged);
  }, [t0, selectedToken?.address]);

  useEffect(() => {
    if (quote) {
      // setMintQuote(quote);
      try {
        if (side === "1") {
          const humanValue = formatUnits(quote.amount0Desired.toString(), 18);
          setEstimateValue1(humanValue.toString());
        } else {
          const humanValue = formatUnits(quote.amount1Desired.toString(), 18);
          setEstimateValue2(humanValue.toString());
        }
      } catch (err) {
        console.error("Failed to convert amountDesired:", err);
      }
    }

    if (error) {
      console.log("error", error);
      // setQuoteError(error);
    }
  }, [quote, error]);

  const handleCopy = (address) => {
    navigator.clipboard
      .writeText(address)
      .then(() => {
        toast.success(`${translate("copiedSuccessfully")}`);
      })
      .catch(() => {
        toast.error("Error");
      });
  };

  const handleScroll = () => {
    const container = containerRef.current;
    if (!container || allTokensLoading) return;

    if (
      container.scrollTop + container.clientHeight >=
      container.scrollHeight - 50
    ) {
      if (currentPage < totalPages) {
        const nextPage = currentPage + 1;
        setCurrentPage(nextPage);
        getAllTokenDetail(nextPage, rowsPerPage, selectToken || "");
      }
    }
  };

  const handleContinue = () => {
    if (!selectedToken || !checkPoolExist) return;
    setStep("AMOUNTS");
    setMaxPrice("");
    setMinPrice("");
    setEstimateValue1("");
    setEstimateValue2("");
    setRangeMode("full");
  };
  function handlePriceChange(which, newValue) {
    if (which === "min") setMinPrice(newValue);
    else setMaxPrice(newValue);
  }

  const resetRangeValues = () => {
    setEstimateValue1("");
    setEstimateValue2("");
    setMinPrice("");
    setMaxPrice("");
  };

  const handleUniswapStep = (which, direction, value, fee) => {
    const num = Number(value);
    if (isNaN(num) || num <= 0) return;

    const spacing = spacingForFee(Number(fee));

    const priceMultiplier = Math.pow(1.0001, spacing);

    const newValue =
      direction === "up" ? num * priceMultiplier : num / priceMultiplier;

    const formatted = parseFloat(newValue.toFixed(6));
    handlePriceChange(which, formatted);
  };

  return (
    <div className="createpositons-pg create-liquidyt-relative">
      <div className="migrate-pg-heading bg-none">
        {/* <div>
          <i onClick={handleGoBack} className="fa fa-arrow-left"></i>
        </div> */}
        <div className="add-liquidity-heading m-auto">
          {translate("addLiquidity.heading")}
        </div>
        <div>
          {(value?.length > 0 ||
            value2?.length > 0 ||
            depositVal?.length > 0) && (
            <div className="clear-all-btn">
              <button
                onClick={() => {
                  setValue("");
                  setValue2("");
                  setDepositVal("");
                }}
              >
                {translate("addLiquidity.clearAll")}
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="bg-none">
        {/* STEP: PAIR */}
        {step === "PAIR" && (
          <div className="migrate-pg-body">
            <p>{translate("addLiquidity.selectPair")}</p>
            <div className="div-add-positons-btn">
              <div className="add-postions-form-btn selected-token-btn add-pos-btn">
                <button
                  type="button"
                  className="btn backdrop-btn-css backdrop-no-modal-btn"
                >
                  <div className="flex-class text-white ">
                    <div>
                      <img
                        src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1733220306/B870CB730078368E_tedoei.webp"
                        alt=""
                        className="modal-img-btn me-2 mb-1"
                      />
                      ETHW
                    </div>{" "}
                  </div>
                </button>
              </div>

              <div className="add-postions-form-btn select-token-btn">
                <button
                  type="button"
                  className="btn add-liquidity-sel-token modal-btn-back-css"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal2"
                >
                  {selectedToken ? (
                    <>
                      <div className="flex-class text-white ">
                        <div>
                          <img
                            src={selectedToken?.image}
                            alt=""
                            className="modal-img-btn me-2 mb-1"
                          />
                          {selectedToken?.symbol}
                        </div>{" "}
                        <div>
                          <i className="fa fa-angle-down grey-clr"></i>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex-class text-white ">
                        {translate("banner.actions.selectToken")}
                        <i className="fa fa-angle-down grey-clr"></i>
                      </div>
                    </>
                  )}
                </button>

                <div
                  className="modal "
                  id="exampleModal2"
                  tabIndex={-1}
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-scrollable text-white">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">
                          {translate("banner.actions.selectToken")}
                        </h1>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div
                        className="modal-body"
                        ref={containerRef}
                        onScroll={handleScroll}
                        style={{ maxHeight: "80vh", overflowY: "auto" }}
                      >
                        <input
                          type="text"
                          name="userToken"
                          placeholder={translate("enterContractAddress")}
                          className="form-control search-input-box search-input-box-2 pt-2 pb-2 mb-2"
                          onChange={selectHandler}
                          autoComplete="off"
                        />
                        {tokenData.length === 0 && allTokensLoading && (
                          <Loading />
                        )}

                        {tokenData.length === 0 && !allTokensLoading && (
                          <div className="suggestion-item">
                            {translate("noResultFound")}
                          </div>
                        )}
                        {tokenData && tokenData.length > 0 && (
                          <>
                            {tokenData.map((suggestion, index) => (
                              <div
                                key={index}
                                className="suggestion-item tokrn-suggestion-data"
                                data-bs-dismiss="modal"
                                onClick={() => saveHandler(suggestion)}
                              >
                                <div className="suggestion-img">
                                  <img src={suggestion?.token.image} alt="" />
                                </div>
                                <div
                                  className="model-data-flex"
                                  style={{ textAlign: "left" }}
                                >
                                  <div className="suggestion-name">
                                    {suggestion?.token.name} (
                                    <strong>
                                      {suggestion?.token.symbol?.toUpperCase()}
                                    </strong>
                                    )
                                  </div>
                                  <div className="suggestion-sym contract-add-model">
                                    {suggestion?.token.address}
                                  </div>
                                </div>
                              </div>
                            ))}
                            {allTokensLoading && <Loading />}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* initial price pool */}
            {!checkPoolExist && selectedToken && (
              <div className="initp-card">
                <div className="initp-row">
                  <div className="initp-input">
                    <div className="initp-header mt-4 ">
                      {translate("createLiq.setInitial")}
                    </div>

                    <div className="initp-input-row">
                      <input
                        type="text"
                        min="0"
                        step="any"
                        placeholder="0"
                        onChange={(e) => {
                          setInitialPriceInput(e.target.value);
                        }}
                        className="no-spin-input"
                        id="number-input-form"
                      />

                      <div className="token-toggle"></div>
                    </div>
                    <div className="set-initp">
                      {selectedToken?.symbol} = 1 ETHW
                    </div>
                    <div className="initp-sub">
                      {/* When initializing a new pool, define the initial exchange
                      rate to establish the starting market price between the
                      paired tokens. */}
                      {translate("createLiq.setInitialInfo")}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Create pair */}
            <div
              className="get-started-btn create-pair-btn mt-4"
              onClick={createPairHandler}
            >
              <button
                className="text-white "
                disabled={checkPoolExist || !selectedToken}
              >
                {loading ? (
                  <Loading />
                ) : checkPoolExist ? (
                  translate("addLiquidity.paired")
                ) : (
                  translate("addLiquidity.createPair")
                )}
              </button>
            </div>

            {/* Fee tier */}
            <div className="fee-tier-div">
              <div>
                <p>
                  {/* {selectedRadio}  */}
                  {percentageMapping[selectedRadio]?.display}{" "}
                  {translate("addLiquidity.feeTier")}
                </p>
                <p>
                  {selectedRadioP} {translate("addLiquidity.selectPercentage")}
                </p>
              </div>
              <div className="hide-edit-btn" onClick={handleToggle}>
                {toggle
                  ? translate("addLiquidity.HideFee")
                  : translate("addLiquidity.editFee")}
              </div>
            </div>
            {toggle && (
              // <div className="toggle-selection-fee toggle-row">
              //   {Object.keys(percentageMapping).map((key) => (
              //     <div className="" key={key}>
              //       <div className="fee-tier-div">
              //         <input
              //           type="radio"
              //           id={key}
              //           name="fee-tier-radio"
              //           value={key}
              //           checked={selectedRadio === `${key}%`}
              //           onChange={handleSelection}
              //         />
              //         <label htmlFor={key}>
              //           {key}% <br />
              //           <span>{percentageMapping[key]}</span>
              //         </label>
              //       </div>
              //     </div>
              //   ))}
              // </div>
              <div className="toggle-selection-fee toggle-row">
                {Object.keys(percentageMapping).map((key) => (
                  <div key={key}>
                    <div className="fee-tier-div">
                      <input
                        type="radio"
                        id={key}
                        name="fee-tier-radio"
                        value={key}
                        checked={selectedRadio === Number(key)}
                        onChange={handleSelection}
                      />
                      <label htmlFor={key}>
                        {percentageMapping[key].display} <br />
                        <span>{percentageMapping[key].label}</span>
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Continue button appears only when pool exists */}
            {selectedToken && checkPoolExist && (
              <div
                className="get-started-btn create-pair-btn mt-4"
                onClick={handleContinue}
              >
                <button className="text-white">
                  {translate("createLiq.continue")}
                </button>
              </div>
            )}
          </div>
        )}
        {/* STEP: V3 select range */}
        {/* {step === "RANGE" && selectedToken && checkPoolExist && (
          <V3AddLiquidityPanel
            token={selectedToken}
            poolAddress={poolAddress}
            // feeTier={FEE_FROM_LABEL(selectedRadio)}
            feeTier={selectedRadio}
            onBack={() => setStep("PAIR")}
            onContinue={() => setStep("AMOUNTS")}
          />
        )} */}
        {/* STEP 3: AMOUNTS deposit handler */}
        {step === "AMOUNTS" && selectedToken && checkPoolExist && (
          <>
            {/* <div className="initp-card-first-pool">
              <div className="initp-header-first-pool">Set price range</div>
            </div>

            <div className="pm-grid">
              {[
                { label: "Min price", value: minPrice, which: "min" },
                { label: "Max price", value: maxPrice, which: "max" },
              ].map(({ label, value, which }) => (
                <div key={which} className="pm-box">
                  <div className="pm-label">{label}</div>

                  <input
                    type="number"
                    step="any"
                    min="0"
                    className="pm-input"
                    value={value}
                    onChange={(e) => handlePriceChange(which, e.target.value)}
                    placeholder={`Enter ${label.toLowerCase()}`}
                  />
                </div>
              ))}
            </div> */}
            {/* {currentPrice != null && (
              <div>Current price: {currentPrice?.toFixed(6)}</div>
            )} */}
            {currentPrice != null && (
              <div className="current-price-box ">
                <div className="current-price-label">
                  {translate("createLiq.currentPrice")}
                </div>
                <div className="current-price-value">
                  <span className="price-number">{Number(currentPrice)}</span>
                  <span className="price-symbol">
                    {" "}
                    {selectedToken?.symbol || "TOKEN"}/ETHW
                  </span>
                </div>
              </div>
            )}

            {/* <div className="initp-card-first-pool">
              <div className="initp-header-first-pool">Set price range</div>
            </div> */}

            {/* Toggle Full / Custom */}
            {/* <div className="range-toggle">
              <label style={{ marginRight: "15px" }}>
                <input
                  type="radio"
                  name="rangeMode"
                  value="full"
                  checked={rangeMode === "full"}
                  onChange={() => {
                    setRangeMode("full");
                    resetRangeValues();
                  }}
                />{" "}
                Full Range
              </label>

              <label>
                <input
                  type="radio"
                  name="rangeMode"
                  value="custom"
                  checked={rangeMode === "custom"}
                  onChange={() => {
                    setRangeMode("custom");
                    resetRangeValues();
                  }}
                />{" "}
                Custom Range
              </label>
            </div> */}
            <div className="range-toggle">
              <div
                className={`toggle-option ${
                  rangeMode === "full" ? "active" : ""
                }`}
                onClick={() => {
                  setRangeMode("full");
                  resetRangeValues();
                }}
              >
                {translate("createLiq.fullRange")}
              </div>
              <div
                className={`toggle-option ${
                  rangeMode === "custom" ? "active" : ""
                }`}
                onClick={() => {
                  setRangeMode("custom");
                  resetRangeValues();
                }}
              >
                {translate("createLiq.customRange")}
              </div>
            </div>

            {/* If Custom Range selected → show inputs */}
            {rangeMode === "custom" ? (
              <>
                {/* <div className="pm-grid mt-4">
                  {[
                    { label: "Min price", value: minPrice, which: "min" },
                    { label: "Max price", value: maxPrice, which: "max" },
                  ].map(({ label, value, which }) => (
                    <div key={which} className="pm-box">
                      <div className="pm-label">{label}</div>

                      <input
                        type="number"
                        step="any"
                        min="0"
                        className="pm-input"
                        value={value}
                        onChange={(e) =>
                          handlePriceChange(which, e.target.value)
                        }
                        placeholder={`Enter ${label.toLowerCase()}`}
                      />
                      <button
                        type="button"
                        className="pm-btn"
                        onClick={() =>
                          handlePriceChange(which, Number(value) + 1)
                        }
                      >
                        +
                      </button>
                      <button
                        type="button"
                        className="pm-btn"
                        onClick={() =>
                          handlePriceChange(
                            which,
                            Math.max(0, Number(value) - 1)
                          )
                        }
                      >
                        –
                      </button>
                    </div>
                  ))}
                </div> */}
                <div className="pm-grid mt-4">
                  {[
                    {
                      label: translate("createLiq.minPrice"),
                      value: minPrice,
                      which: "min",
                    },
                    {
                      label: translate("createLiq.maxPrice"),
                      value: maxPrice,
                      which: "max",
                    },
                  ].map(({ label, value, which }) => (
                    <div key={which} className="pm-box">
                      <div className="pm-label">{label}</div>

                      <div className="pm-input-wrapper">
                        {/* Input on the right */}
                        <input
                          type="text"
                          step="any"
                          min="0"
                          className="pm-input no-spin-input"
                          value={value}
                          onChange={(e) =>
                            handlePriceChange(which, e.target.value)
                          }
                          placeholder={"0"}
                        />
                        <div className="pm-vertical-buttons">
                          {/* <button
                            type="button"
                            className="pm-btn-input pm-btn-up"
                            onClick={() =>
                              handlePriceChange(which, Number(value) + 1)
                            }
                          >
                            +
                          </button>
                          <button
                            type="button"
                            className="pm-btn-input pm-btn-down"
                            onClick={() =>
                              handlePriceChange(
                                which,
                                Math.max(0, Number(value) - 1)
                              )
                            }
                          >
                            –
                          </button> */}
                          <button
                            type="button"
                            className="pm-btn-input pm-btn-up"
                            onClick={() =>
                              handleUniswapStep(
                                which,
                                "up",
                                value,
                                selectedRadio
                              )
                            }
                          >
                            +
                          </button>
                          <button
                            type="button"
                            className="pm-btn-input pm-btn-down"
                            onClick={() =>
                              handleUniswapStep(
                                which,
                                "down",
                                value,
                                selectedRadio
                              )
                            }
                          >
                            –
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div>
                  <div className="pm-grid mt-4">
                    {[
                      {
                        label: translate("createLiq.minPrice"),
                        value: 0,
                        which: "min",
                      },
                      {
                        label: translate("createLiq.maxPrice"),
                        value: "∞",
                        which: "max",
                      },
                    ].map(({ label, value, which }) => (
                      <div key={which} className="pm-box">
                        <div className="pm-label">{label}</div>

                        <input
                          type={value === "∞" ? "text" : "text"}
                          step="any"
                          min="0"
                          className="pm-input no-spin-input"
                          value={value}
                          onChange={(e) =>
                            handlePriceChange(which, e.target.value)
                          }
                          placeholder={`Enter ${label?.toLowerCase()}`}
                          disabled={true}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}

            <p className="mt-3">{translate("addLiquidity.amounts")}</p>
            <div className="set-price-range">
              <div>
                {isSwap ? (
                  <span>
                    {selectedToken
                      ? selectedToken.symbol
                      : translate("banner.actions.selectToken")}
                  </span>
                ) : (
                  <span>ETHW</span>
                )}
                {/* <span>ETHW</span> */}

                <span>
                  <div className="grey-color">
                    <input
                      type="text"
                      value={estimateValue1}
                      onChange={handleETHWInput}
                      inputMode="decimal"
                      min={0}
                      placeholder="0"
                      id="number-input-form"
                      className="text-white "
                      autoComplete="off"
                    />
                  </div>
                </span>
              </div>
            </div>
            <div className="set-price-range">
              <div>
                {isSwap ? (
                  <span>ETHW</span>
                ) : (
                  <span>
                    {selectedToken
                      ? selectedToken.symbol
                      : translate("banner.actions.selectToken")}
                  </span>
                )}
                {/* <span>
                  {selectedToken
                    ? selectedToken.symbol
                    : translate("banner.actions.selectToken")}
                </span> */}

                <span>
                  <div className="grey-color">
                    <input
                      type="text"
                      value={estimateValue2}
                      onChange={handleTokenInput}
                      min={1}
                      placeholder="1"
                      inputMode="decimal"
                      id="number-input-form"
                      autoComplete="off"
                      className="text-white "
                    />
                  </div>
                </span>
              </div>
            </div>
            <div
              className="get-started-btn mt-4"
              style={{ display: "flex", gap: 12 }}
            >
              <button
                type="button"
                className="btn-go-back-v3"
                onClick={() => setStep("PAIR")}
                disabled={depositloader}
              >
                {translate("createLiq.back")}
              </button>

              <button
                type="button deposit-button-v3-position"
                className="text-white"
                onClick={depositHandler}
                disabled={depositloader}
              >
                {depositloader ? (
                  <Loading />
                ) : (
                  translate("addLiquidity.deposit")
                )}
              </button>
            </div>
          </>
        )}
      </div>

      {showModal && (
        <div
          className="modal modal-backcss show d-block"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex={-1}
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog   modal-dialog-centered" role="document">
            <div className="modal-content text-center">
              <div className="modal-header">
                <h5 className="modal-title">{translate("lpAddressLabel")}</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <p style={{ marginBottom: "0" }}>
                  {translate("lpAddressNote")} <br />
                  {poolAddress}{" "}
                  <i
                    className="fa fa-copy ms-1"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleCopy(poolAddress)}
                  ></i>
                </p>
              </div>
              <div className="modal-footer">
                <button
                  style={{
                    backgroundColor: "#00a8e8",
                    color: "#fff",
                    fontWeight: "500",
                  }}
                  type="button"
                  className="btn"
                  onClick={closeModal}
                >
                  {translate("createLiq.close")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreatePositionsV3;
